module.exports = " <div class=component-avatar _v-33e4b85c=\"\"> <div class=avatar _v-33e4b85c=\"\"> <img :src=src alt=\"\" title=\"\" _v-33e4b85c=\"\"> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-33e4b85c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Avatar.vue
// module id = 751
// module chunks = 2